<!-- 机构会议列表页 -->
<template>
  <div class="list-box">
    <Header :pageTitle="''"></Header>
    <XshyItem
      class="hy-list-item"
      v-for="item in list"
      :key="item.id"
      :title="item.title"
      :cover="item.cover"
      :beginTime="item.beginTime.slice(0, 10).replace(RegExp('-', 'g'), '.')"
      :address="item.province + '-' + item.city"
      @click.native="toDetail(item.id, item.open)"
    />
  </div>
</template>

<script>
import Header from "@/views/mobileView/detail/components/detailHeader.vue";
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
export default {
  components: {
    Header,
    XshyItem,
  },
  data() {
    return {
      list: [],
      pageTitle: "",
      param: {
        orgId: this.$route.query.orgId,
        type: 2,
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    // 会议跳转详情
    toDetail(id, open) {
      let out = this.$route.query.out;
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${id}&open=${open}${
            out ? "&out=" + out : ""
          }`,
        "_self"
      );
    },
    async getMeetList() {
      this.loading = true;
      const res = await this.$apis.recomendServe.getListByOrgId(this.param);
      if (res.resultCode === "200") {
        this.list.push(...res.data.list);
      }
    },
  },
  created() {
    this.getMeetList();
  },
};
</script>
<style lang="scss" scoped>
.list-box {
  padding: 56px 12px 12px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .hy-list-item {
    margin: 12px auto;
    padding-bottom: 15px;
    width: 351px;
    // height: 275px;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>
